import React, { useContext } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import UiContent from "../../Components/Common/UiContent";
import { Card, CardHeader, Col, Container, Input, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { TagsInput } from "react-tag-input-component";
import SignContext from "../../contextAPI/Context/SignContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const AddCompany = () => {
  const { AddComapany } = useContext(SignContext);

  const handleSaveCompanyData = async (Values) => {
    const res = await AddComapany(Values);

    return res;
  };

  const validationSchema = Yup.object().shape({
    companyName: Yup.string()
      .required("Company name is required")
      .min(3, "Company name must be at least 3 characters")
      .max(100, "Company name must not exceed 100 characters")
      .trim(),
    companyLocation: Yup.array()
      .min(1, "At least one location is required")
      .of(Yup.string().trim().required("Location cannot be empty"))
      .required("Location is required"),
    companyJobCategorys: Yup.array()
      .min(1, "At least one job category is required")
      .of(Yup.string().trim().required("Job category cannot be empty"))
      .required("Job category is required"),
    companyDepartments: Yup.array()
      .min(1, "At least one department is required")
      .of(Yup.string().trim().required("Department cannot be empty"))
      .required("Department is required"),
    // Contact Person- Optional, validate only if filled
    name1: Yup.string().max(100, "Name must not exceed 100 characters").trim(),
    designation1: Yup.string()
      .max(100, "Designation must not exceed 100 characters")
      .trim(),
    mobile1: Yup.string().test(
      "is-valid-mobile",
      "Mobile number must be exactly 10 digits",
      function (value) {
        if (!value || value.trim() === "") return true;
        return /^[0-9]{10}$/.test(value);
      },
    ),
    email1: Yup.string().test(
      "is-valid-email",
      "Invalid email format",
      function (value) {
        if (!value || value.trim() === "") return true;
        return Yup.string().email().isValidSync(value);
      },
    ),
  });

  return (
    <>
      <ToastContainer />
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            grandParent="Setup"
            parent="Company Master"
            child="Add-Company"
          />
          <Row>
            <Col lg={12}>
              <Formik
                initialValues={{
                  companyName: "",
                  companyLocation: [],
                  companyJobCategorys: [],
                  companyDepartments: [],
                  name1: "",
                  designation1: "",
                  mobile1: "",
                  email1: "",
                }}
                validationSchema={validationSchema}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={async (
                  values,
                  { resetForm, setTouched, setErrors },
                ) => {
                  try {
                    // Validate arrays have values
                    if (
                      values.companyLocation.length === 0 ||
                      values.companyJobCategorys.length === 0 ||
                      values.companyDepartments.length === 0
                    ) {
                      setTouched({
                        companyLocation: true,
                        companyJobCategorys: true,
                        companyDepartments: true,
                      });
                      toast.error("Please fill all required fields!");
                      return;
                    }

                    const res = await handleSaveCompanyData(values);

                    // Only show success if the response is successful
                    if (res && res.success !== false) {
                      toast.success("Company added successfully!");
                      resetForm();
                    }
                  } catch (error) {
                    if (error.response && error.response.data) {
                      const serverErrors = error.response.data.errors;
                      if (serverErrors && Array.isArray(serverErrors)) {
                        // Map backend errors to Formik errors
                        const formikErrors = {};
                        serverErrors.forEach((err) => {
                          formikErrors[err.field] = err.message;
                        });
                        setErrors(formikErrors);
                        toast.error(
                          error.response.data.message || "Validation failed!",
                        );
                      } else {
                        toast.error(
                          error.response.data.message ||
                            "Failed to add company",
                        );
                      }
                    } else {
                      toast.error("Failed to add company. Please try again.");
                    }
                  }
                }}
              >
                {({
                  isSubmitting,
                  handleChange,
                  handleSubmit,
                  errors,
                  touched,
                  values,
                  handleBlur,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Card>
                      <CardHeader>
                        <Row className="g-1 m-1">
                          <Col className="col-sm">
                            <div className="d-flex justify-content-sm-between">
                              <h2 className="card-title mb-0 justify-content-sm-start">
                                <strong>Add Company</strong>
                              </h2>
                            </div>
                          </Col>
                        </Row>
                      </CardHeader>

                      <div className="card-body">
                        <div className="live-preview">
                          <Row className="align-items-center g-3">
                            <Col lg={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Company Name
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="Enter company"
                                    name="companyName"
                                    aria-label="companyName"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.companyName}
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.companyName &&
                                    touched.companyName &&
                                    errors.companyName}
                                </p>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Locations (Press Enter after typing)
                                </label>
                                <div className="mb-3">
                                  <TagsInput
                                    value={values.companyLocation}
                                    onChange={(newValues) => {
                                      setFieldValue(
                                        "companyLocation",
                                        newValues,
                                      );
                                      // Mark field as touched when value changes
                                      if (newValues.length > 0) {
                                        setFieldValue(
                                          "companyLocation",
                                          newValues,
                                          true,
                                        );
                                      }
                                    }}
                                    name="companyLocation"
                                    placeHolder="Type and press Enter"
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.companyLocation &&
                                    touched.companyLocation &&
                                    errors.companyLocation}
                                </p>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-center g-3">
                            <Col lg={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Job Categories (Press Enter after typing)
                                </label>
                                <div className="mb-3">
                                  <TagsInput
                                    value={values.companyJobCategorys}
                                    onChange={(newValues) => {
                                      setFieldValue(
                                        "companyJobCategorys",
                                        newValues,
                                      );
                                      // Mark field as touched when value changes
                                      if (newValues.length > 0) {
                                        setFieldValue(
                                          "companyJobCategorys",
                                          newValues,
                                          true,
                                        );
                                      }
                                    }}
                                    name="companyJobCategorys"
                                    placeHolder="Type and press Enter"
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.companyJobCategorys &&
                                    touched.companyJobCategorys &&
                                    errors.companyJobCategorys}
                                </p>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Job Departments (Press Enter after typing)
                                </label>
                                <div className="mb-3">
                                  <TagsInput
                                    value={values.companyDepartments}
                                    onChange={(newValues) => {
                                      setFieldValue(
                                        "companyDepartments",
                                        newValues,
                                      );
                                      // Mark field as touched when value changes
                                      if (newValues.length > 0) {
                                        setFieldValue(
                                          "companyDepartments",
                                          newValues,
                                          true,
                                        );
                                      }
                                    }}
                                    name="companyDepartments"
                                    placeHolder="Type and press Enter"
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.companyDepartments &&
                                    touched.companyDepartments &&
                                    errors.companyDepartments}
                                </p>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-center g-3 mt-3">
                            <Col lg={3} md={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Contact Person
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="name"
                                    name="name1"
                                    aria-label="companyName"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name1}
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.name1 &&
                                    touched.name1 &&
                                    errors.name1}
                                </p>
                              </div>
                            </Col>
                            <Col lg={3} md={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Designation
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="designation"
                                    name="designation1"
                                    aria-label="companyName"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.designation1}
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.designation1 &&
                                    touched.designation1 &&
                                    errors.designation1}
                                </p>
                              </div>
                            </Col>
                            <Col lg={3} md={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Mobile No.
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="10-digit mobile number"
                                    name="mobile1"
                                    aria-label="companyName"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.mobile1}
                                    maxLength="10"
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.mobile1 &&
                                    touched.mobile1 &&
                                    errors.mobile1}
                                </p>
                              </div>
                            </Col>
                            <Col lg={3} md={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Email ID
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="email"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="example@email.com"
                                    name="email1"
                                    aria-label="companyName"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email1}
                                  />
                                </div>
                                <p className="error text-danger">
                                  {errors.email1 &&
                                    touched.email1 &&
                                    errors.email1}
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Card>
                    <div className="text-end mb-3">
                      <button
                        type="submit"
                        className="btn btn-success w-sm"
                        //   onClick={togglesuccessmodal}
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AddCompany;
